import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Activity } from "lucide-react";
import { useRequestProcessor } from "../../../requestProcessor";
import { useAtom } from "jotai";


import SpinnerLoading from "../../common/SpinnerLoading";
import { activeChildDetail, CorAtom } from "../../../atomstore/store";
import { fetchChildCareData } from "../../../queryfunctions/queryfunctions";

const DevelopmentTab = () => {
    const { useQueryWrapper } = useRequestProcessor();
    const [activeChild] = useAtom(activeChildDetail);
    const [childCare, setChildcare] = useAtom(CorAtom);
    const [currentIndex, setCurrentIndex] = useState(0);


    const gradients = [
        "from-blue-400 to-blue-600",
        "from-pink-400 to-rose-600",
        "from-green-400 to-emerald-600",
        "from-purple-400 to-indigo-600",
        "from-amber-400 to-orange-600",
        "from-fuchsia-400 to-pink-600",
    ];

    // Fetch childcare data
    const { isLoading, isFetching } = useQueryWrapper(
        ["childCare", activeChild?.id],
        () => {
            console.log("[DevelopmentTab] Fetching ChildCare data", {
                child_id: activeChild?.id,
            });
            return fetchChildCareData();
        },
        {
            onSuccess: (data) => {
                console.log("[DevelopmentTab] API Response:", data);
                setChildcare(data);
                setCurrentIndex(0);
            },
        }
    );

    const currentMonthData =
        Array.isArray(childCare) && childCare.length > 0
            ? childCare[currentIndex]
            : null;

    const handleMonthChange = (direction) => {
        if (!childCare || childCare.length === 0) return;
        setCurrentIndex((prev) => {
            if (direction === "prev") {
                return prev < childCare.length - 1 ? prev + 1 : 0;
            } else {
                return prev > 0 ? prev - 1 : childCare.length - 1;

            }
        });
    };

    return (
        <div className="space-y-4">
            {/* Header */}
            <div className="bg-gradient-to-r from-purple-500 to-pink-500 rounded-2xl p-4">
                <div className="flex items-center justify-between">
                    <button
                        className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center"
                        onClick={() => handleMonthChange("prev")}
                    >
                        <ChevronLeft className="w-5 h-5 text-white" />
                    </button>
                    <div className="text-white text-center">
                        <p className="text-lg font-bold">
                            {currentMonthData?.date || "Development Report"}
                        </p>
                        <p className="text-sm opacity-90">Latest Observations</p>
                    </div>
                    <button
                        className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center"
                        onClick={() => handleMonthChange("next")}
                    >
                        <ChevronRight className="w-5 h-5 text-white" />
                    </button>
                </div>
            </div>

            {/* Loader */}
            {(isLoading || isFetching) && (
                <div className="flex justify-center items-center py-8">
                    <SpinnerLoading />
                </div>
            )}

            {/* Data Display */}
            {!isLoading && !isFetching && (
                <>
                    {currentMonthData?.description &&
                        Array.isArray(currentMonthData.description) &&
                        currentMonthData.description.length > 0 ? (
                        <div className="space-y-3">
                            {currentMonthData.description.map((area, idx) => (
                                <div
                                    key={idx}
                                    className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100"
                                >
                                    <div className="flex items-start space-x-3 mb-3">
                                        <div
                                            className={`w-12 h-12 bg-gradient-to-br ${gradients[idx % gradients.length]} rounded-xl flex items-center justify-center flex-shrink-0 shadow-md`}
                                        >
                                            <Activity className="w-6 h-6 text-white" />
                                        </div>
                                        <div className="flex-1">
                                            <h3 className="font-bold text-gray-800">
                                                {area.key}
                                            </h3>
                                            <p
                                                className="text-sm text-gray-700"
                                                dangerouslySetInnerHTML={{
                                                    __html: area.value,
                                                }}
                                            ></p>
                                        </div>
                                    </div>
                                    {/* <div className="space-y-2 ml-2">

                                    </div> */}
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="py-10 text-center text-gray-400 text-sm">
                            No development data available.
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default DevelopmentTab;
